const calculateMaxPersonsRoom = async room => {
    const { beds } = room;

    let total = 0;
    await !!beds.king_size ? total+=beds.king_size*2 : total+=0;
    /**
     * TODO: OJO, necesitamos camarotes en los cuartos!!!
     * */
    await !!beds.queen_size ? total+=beds.queen_size*2 : total+=0;
    await !!beds.double_size ? total+=beds.double_size*2 : total+=0;
    await !!beds.single_size ? total+=beds.single_size*1 : total+=0;

    return total;
};

export default calculateMaxPersonsRoom;


// WEBPACK FOOTER //
// ./src/utils/calculateMaxPersonsRoom.js